import React, { useState } from 'react';

import './fliterStyle.css';

function FliterBlock(props) {
    let [filterName, setFilterName] = useState("All");
    let [sortByName, setSortByName] = useState("Name");
    let tuggleButtonCalss

    const onChangeFilter = (e, text) => {
        setFilterName(e.target.innerText)
        props.onChangeFilter(text);
    }

    const onChangeShortBy = (e, text) => {
        setSortByName(e.target.innerText)
        props.onChangeShortBy(text);
    }
    return (
        <div className='filter-sorting-block'>
            <div className='fliter'>
                <span>Filter By</span>
                <div className="dropdown">
                    <button className="btn  dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        {filterName}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li onClick={(e) => onChangeFilter(e, null)} ><a className="dropdown-item" href="#">ALL</a></li>
                        <li onClick={(e) => onChangeFilter(e, "ACTIVITY")}><a className="dropdown-item" href="#">ACTIVITY</a></li>
                        <li onClick={(e) => onChangeFilter(e, "BLENDED")}><a className="dropdown-item" href="#">BLENDED</a></li>
                        <li onClick={(e) => onChangeFilter(e, "CLASSROOM")}><a className="dropdown-item" href="#">CLASSROOM</a></li>
                    </ul>
                </div>
            </div>
            <div className='sort'>
                <span>Sort By</span>
                <div className="dropdown">
                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        {sortByName}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li onClick={(e) => onChangeShortBy(e, null)}><a className="dropdown-item" href="#">Name</a></li>
                        <li onClick={(e) => onChangeShortBy(e, "date")}><a className="dropdown-item" href="#">Date</a></li>
                        <li onClick={(e) => onChangeShortBy(e, "dateCreated")}><a className="dropdown-item" href="#">Created Date</a></li>
                        <li onClick={(e) => onChangeShortBy(e, "effectiveness")}><a className="dropdown-item" href="#">Effectiveness</a></li>
                        <li onClick={(e) => onChangeShortBy(e, "rating")}><a className="dropdown-item" href="#">Rating</a></li>
                    </ul>
                </div>
                <div className='sort-btn'>
                    <button type='button' className={'cardsIcon ' + (props.selectedStyle.id == 1 ? 'active' : '')} onClick={() => props.toggleStyle(1)}></button>
                    <button type='button' className={'listIcon ' + (props.selectedStyle.id == 2 ? 'active' : '')} onClick={() => props.toggleStyle(2)}></button>
                </div>
            </div>
        </div>
    );
}

export default FliterBlock;